import { Box, Typography } from "@mui/material";
import {fontType} from "../../constants/font";
import {motion} from "framer-motion";
import React from "react";
import {useInView} from "react-intersection-observer";
import telegrafia from "../../assets/success_stories/telegrafia_white_logo.png";
import softec from "../../assets/success_stories/softec-logo.png";
import csob from "../../assets/success_stories/csob-logo.png";
import logoWhite from "../../assets/logo_AAS_academy_RGB_W.svg";
import CourseDescriptionColumn from "../courseDetail/CourseDescriptionColumn";
import CourseDescriptionBlock from "../courseDetail/CourseDescriptionBlock";
import SuccessStoryCitation from "./SuccessStoryCitation";

const SuccessStoryComponent = ({ story }) => {
    const [products, inViewProducts] = useInView({
        triggerOnce: true, // Only trigger the animation once when scrolled into view
    });

    function getLogo(story) {
        let image;
        if (story === 'telegrafia') {
            image = telegrafia;
        } else if (story === 'softec') {
            image = softec;
        } else if (story === 'csob') {
            image = csob;
        }

        return (
            <Box>
                <Box>
                    <img
                        src={image}
                        alt={story}
                        style={{maxWidth: story === 'csob' ? "180px" : "300px"}}
                    />
                </Box>
                <Box>
                        <Typography
                            sx={{
                                color: "white",
                                fontFamily: fontType.semiBold,
                                fontSize: "33px",
                                lineHeight: "39px",
                                marginTop: "20px",
                                marginBottom: "20px"
                            }}
                        >
                            X
                        </Typography>
                </Box>
                <Box>
                    <img
                        src={logoWhite}
                        alt="AAS Academy logo"
                        style={{maxWidth: "300px"}}
                    />
                </Box>
            </Box>
        )
    }

    function getDescription(story) {
        if (story === 'telegrafia') {
            return (
                <>
                    <CourseDescriptionColumn left={true}>
                        <CourseDescriptionBlock title="Prečo sme si vybrali školenie u vás">
                            <br />
                            Pre AAS Solutions sme sa rozhodli na základe pozitívnych referencií a odborného zamerania vašich školení.<br />
                            Oslovila nás kombinácia praktických skúseností lektorov a aktuálnych tém priamo prepojených s praxou v technických a vývojových tímoch.<br />
                            K voľbe školenia u vás prispelo aj to, že sme už pred jeho realizáciou spolupracovali s vašou spoločnosťou na ďalších aktivitách v danej problematike, čo nám potvrdilo vašu odbornosť a spoľahlivý prístup.
                        </CourseDescriptionBlock>
                        <br /><br />
                        <CourseDescriptionBlock title="Ako sme vnímali jeho priebeh">
                            <br />
                            Školenie bolo vedené profesionálne, s dôrazom na pochopenie potrieb účastníkov.<br />
                            Lektori dokázali prispôsobiť tempo a obsah tak, aby bol pre všetkých prínosný.<br />
                            Bolo zrejmé, že obaja majú nielen teoretické, ale aj bohaté praktické skúsenosti v odbore, čo napomohlo lepšiemu pochopeniu problematiky na reálnych príkladoch z praxe.<br />
                            Veľmi pozitívne hodnotíme aj otvorenú diskusiu a možnosť konzultovať konkrétne situácie z našej práce.
                        </CourseDescriptionBlock>
                    </CourseDescriptionColumn>
                    <CourseDescriptionColumn>
                        <CourseDescriptionBlock title="Čo prinieslo nášmu tímu">
                            <br />
                            Školenie nám pomohlo zjednotiť prístup k testovacím procesom, zvýšilo povedomie o moderných metódach a prinieslo nové nápady na zefektívnenie práce.<br />
                            Účastníci získali nielen nové vedomosti, ale aj motiváciu k ďalšiemu rozvoju a zlepšovaniu interných postupov.<br />
                            Zároveň školenie našich kolegov výborne pripravilo aj na záverečnú certifikačnú skúšku ISTQB, čo považujeme za významný prínos pre celý tím aj pre kvalitu našich projektov.
                        </CourseDescriptionBlock>
                        <br /><br /><br />
                        <SuccessStoryCitation
                            citation='"Školenie nám pomohlo zjednotiť prístup k testovacím procesom, zvýšilo povedomie o moderných metódach a prinieslo nové nápady na zefektívnenie práce."'
                            person="Ing. Maroš Vikartovský"
                            role="Team leader, Technical Support and Quality Assurance Department"
                        />
                    </CourseDescriptionColumn>
                </>
            )
        } else if (story === 'softec') {
            return (
                <>
                    <CourseDescriptionColumn left={true}>
                        <CourseDescriptionBlock title="Spoločný úspech v testovaní">
                            <br />
                            Pod vedením spoločnosti AAS Solutions ďalší z členov nášho testerského tímu v SOFTECu úspešne absolvovali školenie ISTQB Foundation Level.
                        </CourseDescriptionBlock>
                        <br /><br />
                        <CourseDescriptionBlock title="Dlhodobý záväzok k rozvoju">
                            <br />
                            Vzdelávanie v oblasti testovania je pre nás dlhodobou prioritou – snažíme sa dopĺňať vedomosti našim novším aj skúsenejším kolegom a zároveň štandardizovať testerské know-how naprieč tímom.<br /><br />
                            So spoločnosťou AAS Solutions máme výborné skúsenosti už z minulosti a radi sa na nich obrátime aj v budúcnosti.
                        </CourseDescriptionBlock>
                    </CourseDescriptionColumn>
                    <CourseDescriptionColumn>
                        <CourseDescriptionBlock title="Výsledky, ktoré prinášajú reálnu hodnotu">
                            <br />
                            Najdôležitejšie však je, že z tohto rozvoja ťažia naši klienti. Vďaka lepšej kvalite testovania, konzistentným štandardom a efektívnejšej spolupráci im dokážeme prinášať spoľahlivejšie riešenia,
                            rýchlejšie nasadenie a vyššiu istotu v dosahovaní ich biznis cieľov.
                        </CourseDescriptionBlock>
                        <br /><br /><br />
                        <SuccessStoryCitation
                            citation='"Školenie nám prinieslo vyššiu profesionalitu, sebavedomie pri práci a väčšiu konkurencieschopnosť na trhu IT služieb."'
                            person="Róbert Morovský"
                            role="Test Lead"
                        />
                    </CourseDescriptionColumn>
                </>
            )
        } else if (story === 'csob') {
            return (
                <>
                    <CourseDescriptionColumn left={true}>
                        <CourseDescriptionBlock title="Prečo sme si vybrali školenie ISTQB od AAS">
                            <br />
                            Školenie od AAS sme si vybrali ako prípravný kurz na certifikáciu ISTQB pre testerov na základe odporúčania.<br />
                            Naším cieľom bolo zvýšiť pripravenosť kolegov na samotnú certifikačnú skúšku.
                        </CourseDescriptionBlock>
                        <br /><br />
                        <CourseDescriptionBlock title="Profesionálny priebeh a praktický prístup">
                            <br />
                            Priebeh školenia hodnotíme veľmi pozitívne – bolo vedené profesionálne, zrozumiteľne a s dôrazom na praktickú aplikáciu v bankovom prostredí.
                        </CourseDescriptionBlock>
                    </CourseDescriptionColumn>
                    <CourseDescriptionColumn>
                        <CourseDescriptionBlock title="Výsledky, ktoré posilnili náš tím">
                            <br />
                            Výsledkom školenia bola vysoká úspešnosť našich testerov na certifikácii ISTQB a zároveň väčšia istota tímu v oblasti test dizajnu a terminológie. <br />
                            Aj vďaka tejto skúsenosti plánujeme školiace služby AAS využívať aj v budúcnosti.
                        </CourseDescriptionBlock>
                        <br /><br /><br />
                        <SuccessStoryCitation
                            citation='"Školenie nám pomohlo zvýšiť úspešnosť pri certifikácii a zároveň posilnilo odbornú istotu nášho testerského tímu."'
                            person="Ján Petrovič"
                            role="Manažér oddelenia, Oddelenie služieb testovania"
                        />
                    </CourseDescriptionColumn>
                </>
            )
        }
    }

    return (
        <Box
            sx={{
                backgroundColor: "#d8d8d8",
                display: "flex",
                alignItems: "center",
                flexDirection: "column",
                position: "relative",
                overflow: "hidden",
            }}
        >
            <Box
                sx={{
                    width: "100%",
                    backgroundColor: "#7b7cd5",
                    position: "relative",
                    display: "flex",
                    justifyContent: "center",
                }}
            >
                <Box
                    sx={{
                        maxWidth: "1440px",
                        width: "100%",
                        display: "flex",
                        justifyContent: "center",
                        position: "relative",
                    }}
                >
                    <Box
                        sx={{
                            display: "flex",
                            marginLeft: { md: "9vw", xs: "20px" },
                            marginRight: { md: "9vw", xs: "20px" },
                            marginTop: "40px",
                            marginBottom: "30px",
                            justifyContent: "space-between",
                            width: "100%",
                            zIndex: 2,
                            flexDirection: { md: "row", xs: "column" },
                        }}
                    >
                        <Box
                            sx={{
                                maxWidth: { md: "100%", xs: "undefined" },
                                width: "100%",
                                justifyContent: "space-between",
                                display: "flex",
                                flexDirection: "column",
                            }}
                        >
                            <Box
                                sx={{
                                    display: "flex",
                                    flexWrap: "wrap",
                                    justifyContent: "center",
                                }}
                            >
                                <Box
                                    sx={{
                                        textAlign: "center",
                                    }}
                                >
                                    { getLogo(story) }
                                </Box>
                            </Box>

                        </Box>
                    </Box>
                </Box>
            </Box>
            <motion.div
                ref={products}
                initial={{ opacity: 0, y: 50 }}
                animate={inViewProducts ? { opacity: 1, y: 0 } : { opacity: 0, y: 50 }}
                transition={{ duration: 0.7 }}
            >
                <Box
                    sx={{
                        display: "flex",
                        zIndex: 2,
                        gap: "50px",
                        marginTop: "50px",
                        maxWidth: "1440px",
                        marginBottom: "40px",
                        flexDirection: { md: "row", xs: "column" },
                    }}
                >
                    { getDescription(story) }
                </Box>
            </motion.div>
        </Box>
    );
};

export default SuccessStoryComponent;
